import React from 'react';
import PropTypes from 'prop-types';

import AddControl from './add_control';
import AssigneeGroup from './assignee_group';
import RemoveControl from './remove_control';

import { connect } from 'react-redux';
import { addAssigneeGroup, removeStep } from './store/workflow/actions';

export class TaskWorkflowStep extends React.Component {
  static propTypes = {
    addAssigneeGroup: PropTypes.func.isRequired,
    assigneeLabel: PropTypes.string.isRequired,
    removeStep: PropTypes.func.isRequired,
    step: PropTypes.shape({
      assigneeGroups: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string.isRequired
      })).isRequired,
      index: PropTypes.number.isRequired
    }).isRequired
  }

  addAssigneeGroup = () => {
    this.props.addAssigneeGroup(this.props.step);
  }

  removeStep = () => {
    this.props.removeStep(this.props.step);
  }

  render() {
    return (
      <div className="panel panel-default">
        <div className="panel-heading">
          <h4 className="m-0">Step {this.props.step.index + 1}</h4>
          <RemoveControl iconSize="lg" onClick={this.removeStep} />
        </div>

        <div className="panel-body">
          {this.renderAssigneeGroups()}
          <AddControl label={`Add ${this.props.assigneeLabel} Group`} onClick={this.addAssigneeGroup} />
        </div>
      </div>
    );
  }

  renderAssigneeGroups() {
    return this.props.step.assigneeGroups.map(assigneeGroup => (
      <AssigneeGroup
        assigneeGroup={assigneeGroup}
        key={assigneeGroup.key}
        step={this.props.step}
      />
    ));
  }
}

const mapStateToProps = state => ({
  assigneeLabel: state.static.assigneeLabel
});

const mapDispatchToProps = {
  addAssigneeGroup,
  removeStep
};

export default connect(mapStateToProps, mapDispatchToProps)(TaskWorkflowStep);
